import { Injectable } from '@angular/core';
import { ScreenSizeRepository } from './screen-size.repository';
import { ScreenSize } from './screen-size.enum';
import { MediaMatcher } from '@angular/cdk/layout';

const SMALL = 640;
const MEDIUM = 1280;
const LARGE = 1366;
const X_LARGE = 1920;

interface BreakpointQuery {
    query: string;
    breakpoint: ScreenSize;
}

const queries: BreakpointQuery[] = [
    { query: `(max-width: ${SMALL}px)`, breakpoint: ScreenSize.Small },
    { query: `(min-width: ${SMALL + 1}px) and (max-width: ${MEDIUM}px)`, breakpoint: ScreenSize.Medium },
    { query: `(min-width: ${MEDIUM + 1}px) and (max-width: ${LARGE}px)`, breakpoint: ScreenSize.Large },
    { query: `(min-width: ${LARGE + 1}px) and (max-width: ${X_LARGE}px)`, breakpoint: ScreenSize.XLarge },
    { query: `(min-width: ${X_LARGE + 1}px)`, breakpoint: ScreenSize.XXLarge }
];

@Injectable({
    providedIn: 'root'
})
export class ScreenSizeService {
    constructor(private screenSizeRepository: ScreenSizeRepository, private mediaMatcher: MediaMatcher) {}

    public init(): void {
        this.setScreenSize(this.currentSize());
        this.setupMediaQueries();
    }

    private setScreenSize(size: ScreenSize): void {
        this.screenSizeRepository.setScreenSize(size);
    }

    private setupMediaQueries(): void {
        queries.forEach((breakpointQuery) => {
            this.mediaMatcher.matchMedia(breakpointQuery.query).addEventListener('change', this.mediaChange(breakpointQuery.breakpoint));
        });
    }

    private mediaChange(size: ScreenSize): (event: MediaQueryListEvent) => void {
        return (event: MediaQueryListEvent) => {
            if (event.matches) {
                this.setScreenSize(size);
            }
        };
    }

    private currentSize(): ScreenSize {
        const current = queries.find((breakpointQuery) => this.mediaMatcher.matchMedia(breakpointQuery.query).matches);
        return current!.breakpoint;
    }
}
